import React, { useState } from "react";
import { TopBar } from "../../CommonComponent/Topbar";
import { FileUploader } from "../../common/FileUploader";
import { Progress, message, Modal, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";

const { Option } = Select;

const NewFileUpload = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [uploadProgress, setUploadProgress] = useState(0);
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState("");

  // Source type modal states
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalResolve, setModalResolve] = useState(null);
  const [selectedSourceType, setSelectedSourceType] = useState("");

  const showSourceTypePrompt = () => {
    return new Promise((resolve) => {
      setIsModalVisible(true);
      setModalResolve(() => resolve);
    });
  };



  const handleModalCancel = () => {
    modalResolve(null);
    setIsModalVisible(false);
  };

  const uploadToApi = async (formData, isUrl = false, isLoading = false) => {
    setLoading(isLoading);
    try {
      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        `${process.env.REACT_APP_API_ROOT}/api/data/upload/`,
        true
      );
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + localStorage.getItem("token")
      );

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percentComplete = Math.round(
            (event.loaded / event.total) * 100
          );
          setUploadProgress(percentComplete);
        }
      };

      xhr.onload = async () => {
        setFile(null);
        setUploadProgress(0);
        setFileInputKey(Date.now());
        if (xhr.status === 400 || xhr.status === 401) {
          message.error(
            "Upload failed due to format issues or lack of relevant data."
          );
          setUploadProgress(0);
          setLoading(false);
          return;
        }
        if (xhr.status === 409) {
          message.error("The file with this name already exist.");
          setUploadProgress(0);
          setLoading(false);
          return;
        }

        const result = JSON.parse(xhr.responseText);
        if (result.message.constructor === Object) {
          let body = {
            DataId: result.message.DataId,
            SourceId: result.message.SourceId,
            SourceType: formData.get("SourceType"),
            
          };

          if (formData.get("SourceType") =="QA") {
            body.Question = result.message.Question;
            body.Answer = result.message.Answer;
          } else {
            body.Context = result.message.Context;
          }

          const secondResponse = await fetch(
            `${process.env.REACT_APP_API_ROOT}/api/data/addQA/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
              body: JSON.stringify(body),
            }
          );

          const resultSecondEndpoint = await secondResponse.json();
          setLoading(false);
          
          navigate("/classroom/QuestionsAndAnswers", {
            state: {
              name: result.message.SourceName || url,
              description: "description",
              currentDataId: result.message.DataId,
              currentSourceId: result.message.SourceId,
              ...(selectedSourceType === "QA"
                ? {
                    questions: result.message.Question,
                    answers: result.message.Answer,
                  }
                : {
                    context: result.message.Context,
                  }),
            },
          });
          setFile(null);
          setUploadProgress(0);
          setFileInputKey(Date.now());
          message.success("Upload completed successfully!");
        } else {
          setLoading(false);
          message.error("Some error occurred!");
        }
      };

      xhr.onerror = () => {
        setLoading(false);
        message.error("An error occurred during upload.");
        setFile(null);
        setUploadProgress(0);
        setFileInputKey(Date.now());
        
      };

      xhr.send(formData);
    } catch (error) {
      console.error(error);
      setFile(null);
      setUploadProgress(0);
      setFileInputKey(Date.now());
      setLoading(false);
      message.error("Unexpected error occurred.");
    }
  };

  const handleFileUpload = async (event) => {
    const uploadedFile = event.target.files[0];
    if (
      uploadedFile &&
      [
        "text/csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "text/plain",
      ].includes(uploadedFile.type)
    ) {
      setFile(uploadedFile);

      const type = await showSourceTypePrompt();
      if (!type) return;

      const formData = new FormData();
      formData.append("DataId", id);
      formData.append("SourceFile", uploadedFile);
      formData.append("SourceName", uploadedFile.name);
      formData.append("SourceType", type);

      uploadToApi(formData);
    } else {
      message.error(
        "Please upload a supported file (.csv, .xlsx, .pdf, .docx, .txt)."
      );
    }
  };

  const handleUrlUpload = async (e) => {
    e.preventDefault();

    const type = await showSourceTypePrompt();
    if (!type) return;

    const formData = new FormData();
    formData.append("DataId", id);
    formData.append("SourceLink", url);
    formData.append("SourceName", url);
    formData.append("SourceType", type);

    uploadToApi(formData, true, true);
  };

  return (
    <div className="w-full">
      <TopBar backArrow={true} text="Upload New File" />
      <div className="mx-8 mt-8 py-6 px-16 bg-white min-h-[500px]">
        <div className="mb-6">
          <form onSubmit={(e) => handleUrlUpload(e)}>
            <label className="block text-lg mb-2 font-medium">
              Upload from URL
            </label>
            <div className="flex gap-4 items-center">
              <input
                placeholder="Enter URL"
                value={url}
                type="url"
                required
                onChange={(e) => setUrl(e.target.value)}
                style={{ border: "1px solid rgba(116, 116, 116, 0.50)" }}
                className="w-[85%] p-2 text-base rounded bg-white cursor-pointer custom-outline"
              />
              <button
                className="primary px-3 py-2"
                disabled={loading}
                type="submit"
              >
                {loading ? "Uploading ..." : "Upload"}
              </button>
            </div>
          </form>
        </div>

        <FileUploader
          key={fileInputKey}
          accept=".csv, .xlsx, .pdf, .docx, .txt"
          supportedFiles="csv, xlsx, pdf, docx, txt"
          text="Upload File"
          icon="/file-upload-icon.svg"
          desc="Supported formats: csv, xlsx, pdf, docx, txt"
          handleFileUpload={handleFileUpload}
        />

        {file && uploadProgress > 0 && (
          <div className="flex flex-col p-6 gap-2 border-2 mt-4 border-gray-200 rounded-md">
            <div className="flex gap-2 items-start">
              <img src="/file-icon.svg" alt="File Icon" />
              <p className="text-medium text-lg">{file.name}</p>
            </div>
            <Progress
              className="flex items-baseline mt-4"
              percent={uploadProgress}
              showInfo={false}
              strokeColor="#497964"
              strokeWidth={5}
            />
          </div>
        )}

        <Modal
          title="Select Data Type"
          open={isModalVisible}
          onCancel={handleModalCancel}
          footer={null} // Remove default footer
        >
          <div className="flex gap-4">
            <div
              className="flex-1 border rounded-md p-4 h-[200px] pt-16 cursor-pointer text-center hover:shadow-md transition duration-200
        border-gray-300 hover:border-[#497964] hover:bg-[#f0f7f5]"
              onClick={() => {
                
                modalResolve("QA");
                setIsModalVisible(false);
              }}
            >
              <h3 className="text-lg font-medium">Question & Answer</h3>
              <p className="text-sm text-gray-500 mt-2">
                Upload with Q&A format
              </p>
            </div>

            <div
              className="flex-1 border rounded-md p-4 pt-16 cursor-pointer text-center hover:shadow-md transition duration-200
        border-gray-300 hover:border-[#497964] hover:bg-[#f0f7f5]"
              onClick={() => {
                
                modalResolve("RAW");
                setIsModalVisible(false);
              }}
            >
              <h3 className="text-lg font-medium">Raw Context</h3>
              <p className="text-sm text-gray-500 mt-2">
                Upload plain context content
              </p>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default NewFileUpload;
